export default "__VITE_ASSET__hlC0Tjlw__"